import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Loader2 } from 'lucide-react';

export type PermissionTriState = 'ALLOW' | 'DENY' | 'INHERIT';

interface RoleOption {
  id: string;
  name: string;
}

interface Props {
  channelName: string;
  channelType: string;
  categoryName: string;
  roles: RoleOption[];
  permissions: readonly string[];
  selectedRoleId: string;
  onRoleChange: (roleId: string) => void;
  values: Record<string, PermissionTriState>;
  onChange: (permission: string, value: PermissionTriState) => void;
  onSave: () => void;
  saving?: boolean;
}

const triStateLabel: Record<PermissionTriState, string> = {
  ALLOW: 'Consenti',
  DENY: 'Nega',
  INHERIT: 'Eredita',
};

export function PermissionDetailPanel({
  channelName,
  channelType,
  categoryName,
  roles,
  permissions,
  selectedRoleId,
  onRoleChange,
  values,
  onChange,
  onSave,
  saving,
}: Props) {
  return (
    <div className="rounded-md border p-4 space-y-4">
      <div>
        <p className="text-sm font-semibold">{channelName}</p>
        <p className="text-xs text-muted-foreground">
          {categoryName} · {channelType}
        </p>
      </div>

      <div className="space-y-2">
        <Label>Ruolo</Label>
        <Select value={selectedRoleId} onValueChange={onRoleChange}>
          <SelectTrigger>
            <SelectValue placeholder="Seleziona ruolo" />
          </SelectTrigger>
          <SelectContent>
            {roles.map((role) => (
              <SelectItem key={role.id} value={role.id}>
                {role.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="space-y-3 max-h-[320px] overflow-auto pr-1">
        {permissions.map((permission) => (
          <div key={permission} className="flex items-center justify-between gap-3">
            <span className="text-sm">{permission}</span>
            <Select
              value={values[permission] || 'INHERIT'}
              onValueChange={(value) => onChange(permission, value as PermissionTriState)}
            >
              <SelectTrigger className="w-[130px] h-8">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {(['INHERIT', 'ALLOW', 'DENY'] as PermissionTriState[]).map((state) => (
                  <SelectItem key={state} value={state}>
                    {triStateLabel[state]}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        ))}
      </div>

      <Button onClick={onSave} disabled={saving || !selectedRoleId} className="w-full">
        {saving ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : null}
        Salva permessi su Discord
      </Button>
    </div>
  );
}
